import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { CheckCircle, OctagonAlert } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { api, ApiError } from '@/lib/axios'
import { Toast } from '../components/Toast'

async function forgotApplicationPasswordRequest(id: string) {
  const { data } = await api.backend.post(
    `/application-account-users-auth/forgot-password/${id}`,
  )
  return data
}

export function useForgotApplicationPassword() {
  const { t } = useTranslation('common')

  const { mutateAsync, isPending } = useMutation<
    unknown,
    AxiosError<ApiError>,
    { id: string }
  >({
    mutationKey: ['/application-account-users-auth/forgot-password'],
    mutationFn: ({ id }) => forgotApplicationPasswordRequest(id),
    onSuccess: () => {
      toast(Toast, {
        data: {
          type: 'success',
          icon: CheckCircle,
          title: t('forgot_password.toast.success.title'),
          description: t('forgot_password.toast.success.description'),
        },
      })
    },
    onError: (error) => {
      toast(Toast, {
        data: {
          type: 'danger',
          icon: OctagonAlert,
          title: t('forgot_password.toast.error.title'),
          description:
            error?.response?.data?.friendlyMessage ||
            t('forgot_password.toast.error.description'),
        },
      })
    },
  })

  const handleForgotApplicationPassword = async (id: string) => {
    return mutateAsync({ id })
  }

  return {
    handleForgotApplicationPassword,
    isSendingForgotApplicationPassword: isPending,
  }
}
